
<template>
  <div class="shareFooter" v-if="flag != 1">
    <div class="content" @click="toStore" >
        <Carousel autoplay :autoplay-speed="5000"  loop dots="none" arrow="never">
            <CarouselItem v-for="(item,index) in content.bottomList" :key="index">
              <div class="demo-carousel">
                <img :src="item.headImage?item.headImage:require('../images/headerImg.png')" alt="头像">
                <div class="div">
                  <p class="p1">{{item.publisherName+' '+item.companyName}}</p>
                  <p class="p2">在用 <i>慧殡葬</i> 邀您一起</p>
                </div>
              </div>             
            </CarouselItem>
        </Carousel>
    </div>
      <div class="btn" @click="toStore">关注Ta</div>
      <v-downTip :popShow="popShow" ></v-downTip>
  </div>
  <!-- 固定宣传语 -->
  <div class="shareFooter2" v-else>
      <span class="sp1">慧殡葬</span> 
      <span>查看更多精彩内容</span>
      <div class="btn" @click="toStore">打开</div>
      <v-downTip :popShow="popShow" ></v-downTip>
  </div>
</template>

<script>
import global from "../js/global.js"
export default {
  data () {
    return {
        popShow:false,
    }
  },
  props:['content','flag'],
  created(){
  },
  mounted(){
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.content)
    },
    closeTip(){
      this.popShow = false;
    }
  }
}
</script>
<style lang="less" scoped>
.shareFooter{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    background: #FBF6F6;
    padding: 12px 30px;
    color: #fff;
    z-index: 9;
    .content{
      float: left;
      width: 460px;
      height: 88px;
      overflow: hidden;
      .demo-carousel{
        background: #FBF6F6;
        overflow: hidden;
      }
      img{
        float: left;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: 24px;
        vertical-align: top;
        float: left;
        margin-left:5px; 
      }
      .div{
        float: left;
        margin-top: -3px;
        color: #5B5C66;
        p{
          width: 365px;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
        }
        .p1{
          line-height: 36px;
          font-size: 26px;
        }
        .p2{
          line-height: 36px;
          font-size: 22px;
          i{
            font-style: normal;
            color: #EF4B4B;
          }
        }
      }
    }
    .btn{
        float: right;
        width: 120px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        font-size: 26px;
        color: #EF4B4B;
        border: 1.75px solid #EF4B4B;
        border-radius: 38px;
        margin-top: 4px;
    }
}
//
.shareFooter2{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    background: #EF4B4B;
    padding: 18px 30px;
    color: #fff;
    z-index: 9;
    .sp1{
        font-size: 28px;
        margin-right: 24px;
    }
    span{
        display: inline-block;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 48px;
    }
    .btn{
        float: right;
        width: 120px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #FFF1EF;
        border-radius: 200px;
        font-size: 24px;
        color: #E27574;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shareFooter.vue